import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const SystemTime = 'SystemTime'
const VerificationCode = "verificationCode"
const Avatar = 'Avatar'
const DiskPath = "diskPath"
const SystemName = "systemName"
const BroadcastId = "broadcastId"
const IsManage = 'isManage'
const MessageType = 'messageType'
const RouterType = 'routerType'
const ScheduleId = 'scheduleId'
const InventoryId = 'inventoryId'
const UserName = 'userName'
const EndOrgName = 'endOrgName'
const UserStatus = 'userStatus'
const ThirdUrl = 'thirdUrl'
const IspassGuide = 'ispassGuide'
const IsReadVersion = 'IsReadVersion'


export function setIsReadVersion (isReadVersion) {
  return Cookies.set(IsReadVersion, isReadVersion)
}
export function setIspassGuide (ispassGuide) {
  return Cookies.set(IspassGuide, ispassGuide)
}
export function getIsReadVersion() {
  return Cookies.get(IsReadVersion)
}
export function getIspassGuide() {
  return Cookies.get(IspassGuide)
}
export function getScheduleId() {
  return Cookies.get(ScheduleId)
}
export function removeScheduleIde() {
  return Cookies.remove(ScheduleId)
}
export function setScheduleId(scheduleId) {
  return Cookies.set(ScheduleId, scheduleId)
}
export function getInventoryId() {
  return Cookies.get(InventoryId)
}
export function removeInventoryId() {
  return Cookies.remove(InventoryId)
}
export function setInventoryId(inventoryId) {
  return Cookies.set(InventoryId, inventoryId)
}
export function getRouterType() {
  return Cookies.get(RouterType)
}
export function setRouterType(routerType) {
  return Cookies.set(RouterType, routerType)
}
export function removeRouterType() {
  return Cookies.remove(RouterType)
}
export function getMessageType() {
  return Cookies.get(MessageType)
}

export function setMessageType(messageType) {
  return Cookies.set(MessageType, messageType)
}
export function removeMessageType() {
  return Cookies.remove(MessageType)
}
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function getIsManage() {
  return Cookies.get(IsManage)
}

export function setIsManage(isManage) {
  return Cookies.set(IsManage, isManage)
}
export function removeIsManage() {
  return Cookies.remove(IsManage)
}
export function getBroadcastId() {
  return Cookies.get(BroadcastId)
}
export function setBroadcastId(broadcastId) {
  return Cookies.set(BroadcastId, broadcastId)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getSysTime() {
  return Cookies.get(SystemTime)
}

export  function  setSysTime(systemTime) {
  return Cookies.set(SystemTime, systemTime)
}

export  function  removeSysTime() {
  return Cookies.remove(SystemTime)
}

export function getVerificationCode() {
  return Cookies.get(VerificationCode)
}
export function setVerificationCode(verificationCode) {
  return Cookies.set(VerificationCode, verificationCode)
}
export function removeVerificationCode() {
  return Cookies.remove(VerificationCode)
}


export  function  getAvatar() {
  // //console.log(Cookies.get(Avatar))
  return Cookies.get(Avatar)
}

export  function  setAvatar(avatar) {
  // //console.log(Cookies.get(avatar))
  return Cookies.set(Avatar, avatar)
}

export  function  removeAvatar() {
  return Cookies.remove(Avatar)
}

export function setRoletype(roletype) {
  return Cookies.set("roletype", roletype)
}

export function getRoletype() {
  return Cookies.get("roletype")
}

//
export  function  removeDiskPath() {
  return Cookies.remove(DiskPath)
}

export function setDiskPath(diskPath) {
  return Cookies.set(DiskPath, diskPath)
}

export function getDiskPath() {
  return Cookies.get(DiskPath)
}

export function setSystemName(systemName) {
  return Cookies.set(SystemName, systemName)
}

export function getSystemName() {
  return Cookies.get(SystemName)
}
export function setUserName(userName) {
  return Cookies.set(UserName, userName)
}

export function getUserName() {
  return Cookies.get(UserName)
}
export function setEndOrgName(endOrgName) {
  return Cookies.set(EndOrgName, endOrgName)
}

export function getEndOrgName() {
  return Cookies.get(EndOrgName)
}

export function getUserStatus() {
  return Cookies.get(UserStatus)
}
export function setUserStatus(userStatus) {
  return Cookies.set(UserStatus, userStatus)
}
export function getThirdUrl() {
  return Cookies.get(ThirdUrl)
}
export function setThirdUrl(thirdUrl) {
  return Cookies.set(ThirdUrl, thirdUrl)
}
export function getMediaTimeState(mediaTimeState) {
  return Cookies.get(mediaTimeState, mediaTimeState)
}
export function setMediaTimeState(mediaTimeState) {
  return Cookies.set(mediaTimeState, mediaTimeState)
}
export function getmediaTimeStateObject(mediaTimeStateObject) {
  return Cookies.get(mediaTimeStateObject, mediaTimeStateObject)
}
export function setmediaTimeStateObject(mediaTimeStateObject) {
  return Cookies.set(mediaTimeStateObject, mediaTimeStateObject)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js